import { MenuItem, SelectField } from 'material-ui';
import React from 'react';

function BasicSelector({ 
    value, 
    dataList = [], 
    onChange, 
    style = {}, 
    iconStyle = {}, 
    labelStyle = {},
    underlineStyle = {},
    fields = [],
    floatingLabelText = '',
    floatingLabelStyle = {},
    hintText = '',
    disabled = false,
    customRender = undefined,
    multiple = false,
    selectionRenderer = undefined,
}) {
    const renderMenuItem = (item) => {
        if (typeof item === 'object' && item !== null) {            
            const values = [];
            fields.forEach(f => values.push(item[f]));

            return (
                <MenuItem 
                    key={item._id}
                    value={item._id}
                    primaryText={values.join(' - ')}
                />
            );
        } 
        return (
            <MenuItem 
                key={item}
                value={item}
                primaryText={item}
            />
        );
    };

    return (
        <SelectField
            floatingLabelText={floatingLabelText}
            hintText={hintText}
            value={value}
            onChange={onChange}
            style={{ width: '100%', ...style }}
            iconStyle={{ ...iconStyle }}
            underlineStyle={{ ...underlineStyle }}
            labelStyle={{ height: '50px', ...labelStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            autoWidth
            disabled={disabled}
            multiple={multiple}
            selectionRenderer={selectionRenderer}
        >
            {
                customRender ||
                dataList.map(item => renderMenuItem(item))
            }
        </SelectField>
    );
}

export default React.memo(BasicSelector);



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/BasicSelector.jsx